import SideMenu from '@/containers/side-menu/SideMenu.vue'
import BulkOutdatedRegister from '@/pages/bulk-outdated-register/BulkOutdatedRegister'

export default {
  path: '/bulk-outdated-register',
  name: 'BulkOutdatedRegister',
  components: {
    mainContent: BulkOutdatedRegister,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'bulk-retroactive-credit'
    },
    breadcrumb: {
      title: 'Registro Retroativo em Lote',
      paths: [
        { title: 'Cadastro' },
        { title: 'Registro Retroativo em Lote' }
      ]
    }
  }
}